import PublicLayout from '../components/PublicLayout.jsx';
import PortfolioSection from '../components/PortfolioSection.jsx';

export default function PortfolioPage() {
  return (
    <PublicLayout>
      <div className="h-24" />
      <PortfolioSection limit={48} showViewAll={false} />
    </PublicLayout>
  );
}
